<!-- 购物车抽屉组件 -->
<template>
  <section>
    <el-drawer :title="$t('shoppingCart.shoppingCart')" :visible.sync="visible" :size="isPC ? '520px' : '100%'" :with-header="false">
    <template v-if="isPC">
      <div class="header p-r">
        <h3>{{$t('shoppingCart.shoppingCart')}}</h3>
        <i class="iconfont icon-a-close-line1 close pointer" @click="close"></i>
      </div>
      <div class="topTip">{{ $t('Components.ShoppingCart.Tips1') }}</div>
      <template v-if="cartList.length">
        <!-- list -->
        <vue-scroll :ops="{scrollPanel:{scrollingX:false}}" style="height: calc(100vh - 160px);">
          <div v-for="warehouseItems in filterSet" :key="warehouseItems.warehouseName">
            <div style="padding: 10px 26px 0" class="f f-b">
              <span class="pointer" @click="warehouseItems.show = !warehouseItems.show">
                {{ $t('Components.ShoppingCart.ShipFrom') }}: {{warehouseItems.warehouseName}}
              </span>
              <i class="el-icon-arrow-down pointer" v-if="!warehouseItems.show" @click="warehouseItems.show = !warehouseItems.show"></i>
              <i class="el-icon-arrow-up pointer" v-else @click="warehouseItems.show = !warehouseItems.show"></i>
            </div>
            <div class="topIcons f" v-if="warehouseItems.show">
              <el-checkbox v-if="cartList.length" v-model="warehouseItems.checkAll" class="checkbox" @change="value=>checkAllClick(warehouseItems, value)" :disabled="warehouseItems.disabled">{{$t('currency.selectAll')}}</el-checkbox>
              <div class="deleteIcon f f--c pointer">
                <el-popconfirm :title="$t('currency.deleteTip')" @confirm="batchDeleteConfirm(warehouseItems)">
                  <i class="el-icon-delete" slot="reference" >{{ $t('Components.ShoppingCart.Delete') }}</i>
                </el-popconfirm>
              </div>
            </div>
            <section v-if="warehouseItems.show">
              <div v-for="(item) in warehouseItems.items" :key="item.id" class="product p-r f" :class="[+item.stock === 0 ? 'disable-product' : '']">
                <!-- 不能勾选的商品： 库存为0 || 商品下架 -->
                <el-checkbox v-model="item.checked" :disabled="+item.stock === 0 || item.disabled || +item.status!== 1" @change="selectChange(item, warehouseItems)"></el-checkbox>
                <oss-img :src="item.imgUrl" :width="100" :height="100" />
                <div class="info">
                  <p class="product-name ellipsis pointer" :class="[+item.status!==1 ? 'disable':'']" @click="toDetail(item.kkProductId)">{{item.skuName}}</p>
                  <p class="specifications" :class="[+item.status!==1 ? 'disable':'']">{{`${item.option1.value || 'color'}，${item.option2.value || 'size'}`}}</p>
                  <!-- <p class="specifications ellipsis" :class="[+item.status===0 ? 'disable':'']">Ship From: {{`${item.countryCn}-${item.warehouseName}`}}</p> -->
                  <p v-if="+item.status===1" class="product-price">
                    <template v-if="item.afterDiscountAmount >= 0">
                      <span class="discount-price">{{ $store.state.common.currencySymbol }}{{item.afterDiscountAmount | currencyConversion}}</span>
                      <span class="original-price">{{ $store.state.common.currencySymbol }}{{item.price | currencyConversion}}</span>
                    </template>
                    <template v-else>{{ $store.state.common.currencySymbol }}{{item.price | currencyConversion}}</template>
                  </p>
                  <p v-else class="product-discontinued">{{ $t('Components.ShoppingCart.ProductHasBeenDiscontinued') }}</p>
                </div>
                <!--  -->
                <div v-show="+item.status===1" class="num f-c-c">
                  <div class="button f-c-c" @click="subtraction(item)"><i class="iconfont icon-subtract-line pointer" style="color: #8B93A3;"></i></div>
                  <!-- <span>{{item.num}}</span> -->
                  <input v-model.number="item.num" type="text" @change="() => productNumChange(item)">
                  <div class="button f-c-c" @click="add(item)"><i class="iconfont icon-a-add-line1 pointer"></i></div>
                </div>
                <!-- 删除按钮 -->
                <el-popconfirm :title="$t('Components.ShoppingCart.Tips2')" @confirm="deleteCart(warehouseItems, item)">
                  <i slot="reference" class="iconfont icon-a-delete-bin-6-line5 delete pointer"></i>
                </el-popconfirm>
              </div>
            </section>
          </div>
        </vue-scroll>
        <div class="f f-a-c" style="margin-top: 20px">
          <!-- <div style="background-color:#F4F6F9;padding:6px;border-radius:6px" class="pointer" @click="openFreightDialog">
            <i class="icon-truck-line iconfont" style="font-size:30px"></i>
          </div> -->
          <el-button type="primary" class="confirm-button" :disabled="confirmOrderDisabled" @click="confirmOrder">{{$t('currency.confirmOrder')}}</el-button>
        </div>
      </template>
      <div v-else class="empty-cart">
        <img src="../assets/img/emptyCart.svg" alt="">
        <p>{{ $t('Components.ShoppingCart.Tips3') }}</p>
      </div>
    </template>
    <div class="mobile-shopping-cart" v-else>
      <div class="mobile-shopping-cart-header f-b-c">
        <p>{{$t('shoppingCart.shoppingCart')}}</p>
        <i class="iconfont icon-a-close-line1" @click="close"></i>
      </div>
      <div v-for="warehouseItems in filterSet" :key="warehouseItems.warehouseName">
        <div class="f f-b" style="padding:.2rem 0">
          <span class="pointer" @click="warehouseItems.show = !warehouseItems.show">
            {{ $t('Components.ShoppingCart.ShipFrom') }}: {{warehouseItems.warehouseName}}
          </span>
          <i class="el-icon-arrow-down pointer" v-if="!warehouseItems.show" @click="warehouseItems.show = !warehouseItems.show"></i>
          <i class="el-icon-arrow-up pointer" v-else @click="warehouseItems.show = !warehouseItems.show"></i>
        </div>
        <div class="topIconsMt f" v-if="warehouseItems.show">
          <el-checkbox v-if="cartList.length" v-model="warehouseItems.checkAll" class="checkbox" @change="value=>checkAllClick(warehouseItems, value)" :disabled="warehouseItems.disabled">{{$t('currency.selectAll')}}</el-checkbox>
          <div class="deleteIcon f f--c pointer">
            <el-popconfirm :title="$t('currency.deleteTip')" @confirm="batchDeleteConfirm(warehouseItems)">
              <i class="el-icon-delete" slot="reference" >{{ $t('Components.ShoppingCart.Delete') }}</i>
            </el-popconfirm>
          </div>
        </div>
        <section v-if="warehouseItems.show">
          <div v-for="(item) in warehouseItems.items" :key="item.id" class="mobile-shopping-cart-product p-r f" :class="[+item.stock === 0 ? 'disable-product' : '']">
            <!-- 不能勾选的商品： 库存为0 || 商品下架 -->
            <el-checkbox v-model="item.checked" :disabled="itemDisabled(item)" @change="selectChange(item, warehouseItems)"></el-checkbox>
            <div class="p-r" style="margin: 0 .2rem 0 .1rem;">
              <oss-img class="mobile-product-img" :src="item.imgUrl" :width="100" :height="100" />
              <div v-if="item.productType === 3" class="tag-pod">POD</div>
              <p class="soldOut" v-if="item.discountType && item.discountType === 1 && item.spikeSoldStock >= item.spikeTotalStock">{{ $t('Components.ShoppingCart.SoldOut') }}</p>
            </div>
            <div class="mobile-product-info">
              <p class="mobile-product-name ellipsis" :class="[+item.status!==1 ? 'disable':'']">{{item.skuName}}</p>
              <p :class="[+item.status!==1 ? 'disable':'']">{{`${item.option1.value || 'color'}，${item.option2.value || 'size'}`}}</p>
              <!-- <p class="ellipsis" :class="[+item.status===0 ? 'disable':'']">Ship From: {{`${item.countryCn}-${item.warehouseName}`}}</p> -->
              <!-- <p v-if="item.discountType && item.discountType === 1" class="f f--c">
                <img src="https://img.kakaclo.com/web-img/index/Group%202174.png" style="width:12px;height:14px;margin-right:4px">
                End in
                {{ getEndTimeFormat(item.discountId)}}
              </p> -->
              <carFlashTime :endTime="item.endTime" v-if="item.discountType && item.discountType === 1"></carFlashTime>
              <div v-if="item.discountType && item.discountType === 1 && item.spikeSoldStock >= item.spikeTotalStock" style="color:#828282;font-size: 14px;font-weight: 400;">
                {{ $t('Components.ShoppingCart.SoldOut') }}
              </div>
              <template v-else>
                <div v-show="+item.status===1" class="mobile-product-num f--c">
                  <div class="button f-c-c" @click="subtraction(item)"><i class="iconfont icon-subtract-line"></i></div>
                  <input v-model.number="item.num" class="input" type="text" @change="() => productNumChange(item)">
                  <div class="button f-c-c" @click="add(item)"><i class="iconfont icon-a-add-line1"></i></div>
                </div>
              </template>
            </div>
            <!-- 删除按钮 -->
            <i slot="reference" class="iconfont icon-a-delete-bin-6-line5" @click="deleteCart(warehouseItems, item)"></i>
            <div v-if="item.afterDiscountAmount >= 0" class="mobile-shopping-cart-product-price mobile-shopping-cart-product-price-discount">
              <div>${{item.afterDiscountAmount}}</div>
              <s>${{item.price}}</s>
            </div>
            <p v-else class="mobile-shopping-cart-product-price">${{item.price | currencyConversion}}</p>
          </div>
        </section>
      </div>
      <div v-if="cartList.length === 0" class="mobile-empty-cart">
        <img src="../assets/img/emptyCart.svg">
        <p>{{ $t('Components.ShoppingCart.Tips3') }}</p>
      </div>

      <div class="mobile-shopping-cart-footer f-b-c">
        <div class="mobile-total">
          <p class="mobile-total-text">{{ $t('Components.ShoppingCart.Total') }}</p>
          <p class="mobile-total-momey">{{ $store.state.common.currencySymbol }}{{totalPrice | currencyConversion}}</p>
        </div>
        <el-button type="primary" class="" :disabled="confirmOrderDisabled" @click="confirmOrder">{{$t('currency.confirmOrder')}}</el-button>
      </div>
    </div>
	</el-drawer>
  <el-dialog
      :title="$t('Components.ShoppingCart.ShippingCalculation')"
      :visible.sync="FreightVisible"
      width="1100px"
      :before-close="FreightHandleClose">
      <p>{{ $t('Components.ShoppingCart.Tips4') }} <span style="color: #99C41C">{{ $t('Components.ShoppingCart.Tips5') }}</span> {{ $t('Components.ShoppingCart.Tips6') }}</p>
      <p>{{ $t('Components.ShoppingCart.Tips7') }}</p>
      <el-tabs v-model="FreightActiveName" @tab-click="freightTabsHandleClick">
        <el-tab-pane :label="warehouseItems.countryCode" :name="warehouseItems.countryCode" v-for="warehouseItems in filterSet" :key="warehouseItems.warehouseName">
          <div >
            <div class="f f--c">
              <div>
                  {{ $t('Components.ShoppingCart.ShippingTo') }}:
                  <el-select :placeholder="$t('Components.ShoppingCart.Select')" v-model="warehouseItems.termini">
                    <el-option v-for="item in warehouseItems.shipToSelectList" :key="item.code" :value="item.code" :label="item.name"></el-option>
                  </el-select>
              </div>
              <div>
                {{ $t('Components.ShoppingCart.ShippingMehod') }}:
                <el-select :placeholder="$t('Components.ShoppingCart.Select')" v-model="warehouseItems.methods">
                    <el-option v-for="item in warehouseItems.channelList" :key="item.channelCode" :value="item.channelCode" :label="item.channelNameEn"></el-option>
                  </el-select>
              </div>
            </div>
            <div style="margin-top:20px">
              <el-table
                :data="warehouseItems.items"
                style="width: 100%"
                @selection-change="value=>selectionChange(warehouseItems, value)"
                row-key="id">
                <el-table-column
                  type="selection"
                  width="55"
                  :reserve-selection="true">
                </el-table-column>
                <el-table-column
                  prop="date"
                  :label="$t('Components.ShoppingCart.Description')">
                  <template slot-scope="scope">
                    <div class="f">
                        <div style="margin: 0px 8px 0 0;">
                          <el-popover placement="right" width="280" trigger="hover">
                            <el-image  fit="cover"  :src="scope.row.imgUrl" ></el-image>
                            <el-image slot="reference" :src="scope.row.imgUrl" fit="cover" style="width: 64px;height: 64px" :class="{disabledColumn: scope.row.status !== 1}" />
                          </el-popover>
                        </div>
                        <div class="product_title">
                          <el-tooltip effect="dark" :content="scope.row.skuName" placement="top">
                              <div class="ellipsis1">{{ scope.row.skuName }}</div>
                          </el-tooltip>
                          <div v-if="scope.row.option1">{{scope.row.option1.name}}: {{ scope.row.option1.value }}</div>
                          <div v-if="scope.row.option2">{{scope.row.option2.name}}: {{ scope.row.option2.value }}</div>
                        </div>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                  :label="$t('Components.ShoppingCart.Qty')"
                  width="180">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('Components.ShoppingCart.UnitPrice')"
                  width="190">
                  <template slot-scope="scope">
                    <div v-if="+scope.row.status===1">
                      <template v-if="scope.row.afterDiscountAmount >= 0">
                        <p style="font-weight:bold">{{ $store.state.common.currencySymbol }}{{scope.row.afterDiscountAmount | currencyConversion}}</p>
                        <p style="font-size:12px;color:#747A87;text-decoration:line-through">{{ $store.state.common.currencySymbol }}{{scope.row.price | currencyConversion}}</p>
                      </template>
                      <template v-else>{{ $store.state.common.currencySymbol }}{{scope.row.price | currencyConversion}}</template>
                    </div>
                    <div v-else>{{ $t('Components.ShoppingCart.ProductHasBeenDiscontinued') }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('Components.ShoppingCart.Weight')"
                  width="220"
                >
                  <template slot-scope="scope">
                    <div class="f-b">
                      <span style="font-weight:bold">{{scope.row.packageWeight}}g</span>
                      <i class="el-icon-delete pointer" style="font-size:20px"></i>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="f-b">
        <span style="color:#99C41C">{{ $t('Components.ShoppingCart.Tips8') }}</span>
        <el-button type="primary" @click="dialogVisible = false">{{ $t('Components.ShoppingCart.Submit') }}</el-button>
      </span>
    </el-dialog>
    <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
  </section>
</template>

<script>
import API from '@/api'
import bus from '@/util/bus.js'
import _ from 'lodash'
import OssImg from './OssImg.vue'
import dayjs from 'dayjs'
import carFlashTime from '@/views/index/components/carFlashTime.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'

export default {
  components: { OssImg, carFlashTime, AccountSetting },
  data() {
    return {
      visible: false,
      checkedAll: false,
      timer: null,
      cartList: [],
      filterSet: {}, // 分类后的数据
      FreightVisible: false,
      FreightActiveName: '',
      endTimeObj: {}, // key为 discountId
      endTimeInterval: null,
      currentTime: dayjs().valueOf(),
      day: 0,
      time: '0000',
      hours: '00'
    }
  },
  created() {
    bus.$on('getCartList', this.getCartList)
    bus.$on('showCartDrawer', this.show)
    this.$once('hook:beforeDestroy', () => {
      bus.$off('getCartList')
      bus.$off('showCartDrawer')
    })
  },
  computed: {
    confirmOrderDisabled() {
      return !this.cartList.some(item => item.checked)
    },
    totalPrice() {
      return this.cartList.reduce((price, item) => {
        return item.checked ? (item.afterDiscountAmount ? item.afterDiscountAmount : item.price) * item.num + price : price
      }, 0)
    }
    // productIsDiasbled() {
    //   let isDisabled = false
    //   let checkProducts = this.cartList.filter(e=>e.checked)

    //   return
    // }
  },
  watch: {
    visible() {
      if (this.visible === false) {
        this.cartList.forEach(item => {
          item.checked = false
        })
      }
    },
    cartList: {
      deep: true,
      handler: function(cartList) {
        const shoppingCartSkuNum = cartList.reduce((num, item) => {
          return num + +item.num
        }, 0)
        this.$store.commit('common/set', { shoppingCartSkuNum })
      }
    }
  },
  methods: {
    getCartList() {
      if (!this.$store.state.common.userId) {
        this.buildCart()
        return
      }
      API.getCartList().then(result => {
        result.data.forEach(item => {
          // 将option字符串保存一下，创建订单的时候要用
          item.option1String = item.option1
          item.option2String = item.option2
          try {
            item.option1 = JSON.parse(item.option1)
            item.option2 = JSON.parse(item.option2)
          } catch (error) {
            console.log(error)
            item.option1 = item.option2 = {}
          }
          item.checked = false
          item.disabled = false
        })
        this.cartList = result.data
        // 根据仓库分类
        const filterSet = []
        this.cartList.forEach(e => {
          let target = filterSet.find(ee => ee.warehouseCode === e.warehouseCode)
          if (!target) {
            const item = {
              checkAll: false,
              warehouseName: e.countryCn,
              items: [e],
              show: true,
              countryCode: e.countryCode,
              warehouseCode: e.warehouseCode,
              shipTo: undefined,
              selections: [],
              warehouseType: e.warehouseType,
              warehouseId: e.warehouseId,
              disabled: false
            }
            filterSet.push(item)
          } else {
            target.items.push(e)
          }
          if (e.discountId && !this.endTimeObj[e.discountId]) this.endTimeObj[e.discountId] = e.endTime
        })
        this.filterSet = filterSet
        if (this.timer) clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.updatePrice()
        }, 1000)
      })
    },
    // 未登陆使用缓存里的购物车
    buildCart() {
      this.cartList = this.$store.state.common.cartList

      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.updatePrice()
      }, 1000)
    },
    deleteCart(warehouseItems, item) {
      let index = warehouseItems.items.findIndex(e => e.id === item.id)
      let index2 = this.cartList.findIndex(e => e.id === item.id)
      if (!this.$store.state.common.userId) {
        warehouseItems.items.splice(index, 1)
        this.cartList.splice(index2, 1)
        return
      }
      API.deleteCart([item.id]).then(result => {
        warehouseItems.items.splice(index, 1)
        this.cartList.splice(index2, 1)
      })
      if (this.filterSet) {
        for (let group of this.filterSet) {
          this.$set(group, 'disabled', false)
          group.items.forEach(e => {
            this.$set(e, 'disabled', false)
          })
        }
      }
      this.show()
    },
    show() {
      this.getCartList()
      this.visible = true
    },
    close() {
      this.visible = false
      this.cartList.forEach(item => (item.disabled = false))
    },
    confirmOrder() {
      if (this.$store.state.common.email === '') {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.createOrder()
      }
    },
    createOrder() {
      let checkedList = []
      this.filterSet.forEach(item => {
        if (!checkedList.length && item.items.filter(e => e.checked).length) checkedList = item.items.filter(e => e.checked)
      })
      // if (this.isOverweight(checkedList)) return this.$message.info(this.$t('promptText.msg6'))
      window.gtag('event', 'confirm_order')
      this.gtag(checkedList)
      this.$router.push({
        path: '/confirm-order',
        query: {
          kkProductId: checkedList.map(item => item.kkProductId).join(','),
          skuCode: checkedList.map(item => item.skuCode).join(',')
        }
      })
      this.close()
    },
    setSuccess() {
      this.createOrder()
    },
    /**
     * 商品总重量加起来不超过30kg
     */
    isOverweight(cartList) {
      const weight = cartList.reduce((weight, item) => {
        return weight + (+item.packageWeight * +item.num)
      }, 0)
      return weight > 30 * 1000
    },
    checkAllClick(warehouseItems, value) {
      console.log(value)
      warehouseItems.items.forEach(e => {
        if (!this.itemDisabled(e)) e.checked = value
      })
      if (value) {
        for (let group of this.filterSet) {
          this.$set(group, 'disabled', group.warehouseCode !== warehouseItems.warehouseCode)
          group.items.forEach(e => {
            this.$set(e, 'disabled', group.warehouseCode !== warehouseItems.warehouseCode)
          })
        }
      } else {
        for (let group of this.filterSet) {
          this.$set(group, 'disabled', false)
          group.items.forEach(e => {
            this.$set(e, 'disabled', false)
          })
        }
      }
    },
    toDetail(id) {
      const path = this.$route.path
      const to = `/product-detail?id=${id}`
      if (path === '/product-detail') {
        if (+this.$route.query.id === +id) return
        bus.$emit('reloadProductDetail', id)
      }
      this.visible = false
      this.$router.push(to)
    },
    selectChange(product, warehouseItems) {
      warehouseItems.checkAll = warehouseItems.items.every(item => item.checked)
      let isHaveChoice = warehouseItems.items.some(e => e.checked)
      if (isHaveChoice) {
        for (let group of this.filterSet) {
          this.$set(group, 'disabled', group.warehouseCode !== warehouseItems.warehouseCode)
          group.items.forEach(e => {
            this.$set(e, 'disabled', group.warehouseCode !== warehouseItems.warehouseCode)
          })
        }
      } else {
        for (let group of this.filterSet) {
          this.$set(group, 'disabled', false)
          group.items.forEach(e => {
            this.$set(e, 'disabled', false)
          })
        }
      }
    },
    subtraction(product) {
      if (+product.num === 1) return
      product.num = +product.num - 1
      if (!this.$store.state.common.userId) {
        this.$store.commit('common/set', {
          cartList: this.cartList
        })
        return
      }
      this.updateCartNumber(product.skuCode, product.warehouseCode, product.num)
    },
    add(product) {
      if (+product.num === +product.stock) {
        this.$message.info(this.$t('promptText.msg7') + ` ${product.stock}`)
        return
      }
      product.num = +product.num + 1
      if (!this.$store.state.common.userId) {
        this.$store.commit('common/set', {
          cartList: this.cartList
        })
        return
      }
      this.updateCartNumber(product.skuCode, product.warehouseCode, product.num)
    },
    productNumChange(product) {
      product.num = ~~Number(product.num)
      if (product.num <= 0) product.num = 1
      if (product.num > product.stock) {
        product.num = product.stock
        this.$message.info(this.$t('promptText.msg7') + ` ${product.stock}`)
      }
      this.updateCartNumber(product.skuCode, product.warehouseCode, product.num)
    },
    updateCartNumber: _.debounce(function(skuCode, warehouseCode, num) {
      API.updateCartNumber({ skuCode, warehouseCode, num })
    }, 1000, { leading: false, trailing: true }),
    updatePrice() {
      const now = new Date().getTime()
      this.cartList.forEach(item => {
        if (item.endTime && now > item.endTime) {
          this.$set(item, 'endTime', undefined)
          this.$set(item, 'afterDiscountAmount', undefined)
          this.$set(item, 'discountPercent', undefined)
          this.$set(item, 'promotionAmount', undefined)
          this.$set(item, 'discountId', undefined)
        }
      })
      this.currentTime += 1000
    },
    // 增强型电子商务代码
    gtag(data) {
      let items = data.map(item => ({
        id: item.kkProductId,
        name: item.skuName,
        quantity: item.num,
        price: item.afterDiscountAmount ? item.afterDiscountAmount : item.price
      }))
      window.gtag('event', 'begin_checkout', {
        items
      })
    },
    batchDeleteConfirm(warehouseItems) {
      const ids = warehouseItems.items.filter(e => e.checked).map(e => e.id)
      if (!ids.length) return
      API.deleteCart(ids).then(result => {
        this.getCartList()
      })
    },
    openFreightDialog() {
      // 没选则默认第一个
      if (!this.FreightActiveName) {
        this.FreightActiveName = this.filterSet[0].countryCode
        this.getShippableCountryList(this.filterSet[0])
      }
      this.FreightVisible = true
    },
    FreightHandleClose() {
      this.FreightVisible = false
    },
    /**
     * 获取可配送国家列表
     */
    getShippableCountryList(warehouseItems) {
      if (['DE', 'US', 'GB'].includes(warehouseItems.countryCode)) {
        const shipToMap = {
          US: [{ code: 'US', name: 'United States' }],
          DE: [{ code: 'DE', name: 'Germany' }],
          GB: [{ code: 'GB', name: 'United Kingdom' }]
        }
        this.$set(warehouseItems, 'shipToSelectList', shipToMap[warehouseItems.countryCode])
        return
      }
      API.getSelectList({
        type: 7,
        param: warehouseItems.warehouseCode
      }).then(result => {
        result.data.sort((a, b) => {
          return a.name.charCodeAt(0) - b.name.charCodeAt(0)
        })
        this.$set(warehouseItems, 'shipToSelectList', result.data)
        // 国家列表有美国默认选择美国
        const find = warehouseItems.shipToSelectList.find(item => item.code === 'US')
        warehouseItems.termini = find ? 'US' : _.get(this.shippableCountryList, '0.code', undefined)
        this.getChannel(warehouseItems)
      })
    },
    freightTabsHandleClick(tab, event) {
      console.log(this.FreightActiveName)
    },
    selectionChange(warehouseItems, value) {
      warehouseItems.selections = value
    },
    getChannel(warehouseItems) {
      API.getLogisticsChannel({ warehouses: [{
        warehouseCode: warehouseItems.warehouseCode,
        termini: warehouseItems.termini,
        channelGrouping: warehouseItems.warehouseType,
        warehouseId: warehouseItems.warehouseId,
        products: [{
          skuCode: warehouseItems.items[0].skuCode,
          quantity: 1,
          kkProductId: warehouseItems.items[0].kkProductId
        }]
      }] }).then(result => {
        if (_.get(result, 'data.0.code') !== 10000) {
          this.channelList = []
          this.activatedChannel = {}
          return console.error(_.get(result, 'data.0.message'))
        }
        const channelList = _.get(result, 'data.0.data', [])
        channelList.map(item => {
          item.deliveryDayNum = +item.deliveryTime.split('~')[0]
        })
        this.$set(warehouseItems, 'channelList', channelList)
        this.freight = _.minBy(channelList, function(freight) {
          return Number(String(freight.deliveryTime).split('~')[0])
        })
      })
    },
    selectableFunc(row, index) {
      let firstSelect = this.cartList.find(e => e.checked)
      if (!firstSelect) return true
      return row.warehouseCode === firstSelect.warehouseCode
    },
    getEndTimeFormat(discountId) {
      if (this.endTimeObj[discountId] - this.currentTime < 0) return '00:00:00'
      return dayjs(this.endTimeObj[discountId] - this.currentTime).format('HH:mm:ss')
    },
    itemDisabled(item) {
      if (item.discountType && item.discountType === 1 && item.spikeSoldStock >= item.spikeTotalStock) return true
      return +item.stock === 0 || item.disabled || +item.status !== 1
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.header{
	width: 514px;
  padding: 25px 25px 0;
	h3{
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
		color: #000000;
		padding-bottom: 10px;
	}
	.checkbox{
		font-size: 14px;
		line-height: 21px;
		color: #8B93A3;
	}
	.close{
		position: absolute;
		top: 30px;
		right: 20px;
		font-size: 20px;
	}
}
.topTip {
  color: #99C41C;
  padding: 4px 25px 4px;
  border-bottom: 0.5px solid #CDD4DD;
}
.product{
	margin-top: 20px;
	padding: 0 26px;
	img{
		width: 97px;
		height: 97px;
		border: 0.5px solid #CDD4DD;
		border-radius: 6px;
		margin: 0 12px 0 17px;
    object-fit: cover;
	}
	.info{
		.product-name{
			width: 322px;
			font-size: 14px;
			line-height: 18px;
			color: #10141D;
			padding-bottom: 6px;
		}
		.specifications{
			font-size: 14px;
			color: #747A87;
		}
		.product-price{
			font-weight: 500;
			font-size: 16px;
			line-height: 24px;
			color: #10141D;
			padding-top: 6px;
		}
    .product-discontinued{
      color: #A6100C;
      line-height: 30px
    }
	}
	.delete{
		position: absolute;
		top: 25px;
		right: 30px;
    color: #8B93A3;
	}
  .num{
    position: absolute;
    right: 70px;
    bottom: 0;
    .button{
      width: 28px;
      height: 28px;
      border: 0.5px solid #CDD4DD;
      border-radius: 100px;
    }
    input{
      font-size: 16px;
      line-height: 24px;
      color: #99C41C;
      text-align: center;
      display: inline-block;
      width: 40px;
      border: none;
      outline: none;
    }
  }
  .discount-price{
    font-weight: 500;
    font-size: 16px;
    color: #A6100C;
  }
  .original-price{
    font-weight: 400;
    font-size: 14px;
    color: #747A87;
    padding: 0 15px 0 10px;
    text-decoration: line-through;
  }
}
.disable-product{
  img{
    opacity: .5;
  }
  *{
    color: #CDD4DD!important;
  }
}
.confirm-button{
	// display: block;
	width: 300px;
	height: 50px;
	// margin: 10px auto;
}
.empty-cart{
  img{
    display: block;
    width: 290px;
    height: 188px;
    margin: 20vh auto 0 auto;
  }
  p{
    font-size: 16px;
    text-align: center;
    color: #747A87;
    padding-top: 80px;
  }
}
.disable{
  color: #CDD4DD!important;
}
.topIcons {
  padding: 10px 26px 0;
  .deleteIcon {
    margin-left: 8px;
    color: #747A87;
  }
}
</style>
<!-- 移动端样式 -->
<style lang="scss" scoped>
.mobile-shopping-cart{
  padding: .8rem .3rem .96rem .3rem;
  .mobile-shopping-cart-header{
    position: absolute;
    top: 0;
    right: .4rem;
    left: 0;
    width: 100%;
    height: .8rem;
    line-height: .8rem;
    font-size: .32rem;
    color: #7B7B7B;
    font-weight: 400;
    padding: 0 .3rem;
    background: white;
    z-index: 9;
    .icon-a-close-line1{
      font-size: .42rem;
    }
  }
  .mobile-shopping-cart-product{
    padding: .2rem 0;
    border-bottom: 1px solid #DEDEDE;
    .mobile-product-img{
      flex-shrink: 0;
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 8px;
      object-fit: cover;
    }
    .mobile-product-info{
      font-size: .24rem;
      p{
        max-width: 55vw;
      }
      .mobile-product-num{
        padding-top: .16rem;
        width: 85%;
        .button{
          width: .56rem;
          height: .56rem;
          border: 0.5px solid #B6B6B6;
          border-radius: 100%;
        }
        input{
          font-size: .32rem;
          color: #99C41C;
          text-align: center;
          display: inline-block;
          width: .8rem;
          border: none;
          outline: none;
        }
      }
    }
    .icon-a-delete-bin-6-line5{
      position: absolute;
      right: 0;
      top: .16rem;
      color: #B6B6B6;
    }
    .mobile-shopping-cart-product-price{
      position: absolute;
      right: 0;
      bottom: .3rem;
      font-weight: 600;
      font-size: .32rem;
    }
    .mobile-shopping-cart-product-price-discount{
      bottom: .1rem;
      text-align: right;
      >div{
        color:#A6100C;
        font-size:.32rem;
        line-height:.2rem;
      }
      >s{
        color:#747A87;
        font-size:.24rem;
        font-weight:500;
      }
    }
  }
  .mobile-shopping-cart-footer{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: .96rem;
    padding: 0 .3rem;
    background: white;
    z-index: 9;
    .mobile-total{
      padding-right: .5rem;
      .mobile-total-text{
        color: #AAAAAA;
        font-size: .28rem;
      }
      .mobile-total-momey{
        font-weight: 600;
        font-size: .4rem;
        line-height: .6rem;
        color: #AB1E1A;
      }
    }
    .el-button{
      width: 100%;
    }
  }
}
.mobile-empty-cart{
  img{
    display: block;
    width: 60vw;
    margin: 20vh auto 0 auto;
  }
  p{
    font-size: .36rem;
    text-align: center;
    color: #747A87;
    padding-top: 1.6rem;
  }
}
.topIconsMt {
  // padding: 0 .3rem 0 .3rem;
  .deleteIcon {
    margin-left: 8px;
    color: #747A87;
  }
}
.soldOut{
  position: absolute;
  width: 1.4rem;
  height: .4rem;
  top: 1rem;
  left: .1rem;
  right: 0;
  background-color: #D9D9D9;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  text-align: center;
  line-height: .4rem;
  font-size: 10px;
}
.tag-pod{
  position: absolute;
  bottom: 10px;
  background-color: #F7FCEB;
  width: 100%;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  text-align:center;
  color: #9AC331;
}
</style>
